import React from 'react'
import { compose, withProps } from 'recompose'
import { getFileSrc } from '@infotech/filestorage'
import { withToken } from '@infotech/auth'

const Download = ({ fileSrc, data, value = data }) => (
  <a href={fileSrc}>
    { value && `download`}
  </a>
)

const enhance = compose(
  withToken,
  withProps(
    ({ data, value = data, token }) => ({
      fileSrc: getFileSrc(value, { token }),
    })
  )
)

export default enhance(Download)
